export const PARAMETER_VALUE_TYPE = {
    INTEGER: 'int',
    FLOAT: 'float',
    STRING: 'str',
    BOOLEAN: 'bool',
};

export const parameterValueTypeChoices = translate => [
    { id: PARAMETER_VALUE_TYPE.INTEGER, name: translate('resources.parameter.types.integer') },
    { id: PARAMETER_VALUE_TYPE.FLOAT, name: translate('resources.parameter.types.float') },
    { id: PARAMETER_VALUE_TYPE.STRING, name: translate('resources.parameter.types.string') },
    { id: PARAMETER_VALUE_TYPE.BOOLEAN, name: translate('resources.parameter.types.boolean') },
];

export const parameterBooleanValueChoices = translate => [
    { id: 'true', name: translate('common.boolean.yes') },
    { id: 'false', name: translate('common.boolean.no') },
];

export const buildParameterName = (systemName, type) => (systemName && type ? `${systemName}_${type}` : '');
